var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileFb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 9C29.3869 9 31.6761 9.94821 33.364 11.636C35.0518 13.3239 36 15.6131 36 18C36 20.3869 35.0518 22.6761 33.364 24.364C31.6761 26.0518 29.3869 27 27 27C24.613 27 22.3239 26.0518 20.636 24.364C18.9482 22.6761 18 20.3869 18 18C18 15.6131 18.9482 13.3239 20.636 11.636C22.3239 9.94821 24.613 9 27 9ZM27 31.5C36.945 31.5 45 35.5275 45 40.5V45H9V40.5C9 35.5275 17.055 31.5 27 31.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileFb);
export default __webpack_public_path__ + "static/media/profileFb.089a70a54c01d8334107d4b835514b19.svg";
export { ForwardRef as ReactComponent };